<template>
  <div>
    <div style="text-align: center; padding-top: 80px;">Return to the app to view the results.</div>
    <button style="margin: 20px auto; display: block; color: #fff; background: #409EFF; border-color: #409EFF;" @click="openApp">OPEN APP</button>
  </div>
</template>

<script>
export default {
  methods: {
    openApp() {
      window.open('cito://bogpayresult')
    }
  },
  created() {
    const scheme = 'cito://bogpayresult'
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = scheme

    document.body.appendChild(iframe)
  }
}
</script>
